import { PixelCrop } from 'react-image-crop';

export async function canvasPreview(
  image: HTMLImageElement,
  canvas: HTMLCanvasElement,
  crop: PixelCrop,
  scale = 1,
  rotate = 0,
) {
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  console.log('[canvasPreview] Input params:', {
    crop,
    scale,
    rotate,
    imageDisplaySize: { width: image.width, height: image.height },
    imageNaturalSize: { width: image.naturalWidth, height: image.naturalHeight }
  });

  // Ratio between displayed size and natural size
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  // Convert the crop from display coordinates to natural image coordinates
  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;
  const cropWidth = crop.width * scaleX;
  const cropHeight = crop.height * scaleY;

  console.log('[canvasPreview] Crop in natural coordinates:', {
    cropX,
    cropY,
    cropWidth,
    cropHeight
  });

  // Cap the crop dimensions to prevent browser limits
  const MAX_CANVAS_SIZE = 4096;
  let outputScale = 1;
  if (cropWidth > MAX_CANVAS_SIZE || cropHeight > MAX_CANVAS_SIZE) {
    outputScale = Math.min(
      MAX_CANVAS_SIZE / cropWidth,
      MAX_CANVAS_SIZE / cropHeight
    );
  }

  // Calculate output dimensions (accounting for rotation)
  // NOTE: scale parameter is IGNORED - it's only for display zoom, not output scaling
  const rotateRads = (rotate * Math.PI) / 180;
  const sin = Math.abs(Math.sin(rotateRads));
  const cos = Math.abs(Math.cos(rotateRads));

  // Rotated dimensions (at natural size, not scaled)
  const rotatedWidth = cropWidth * cos + cropHeight * sin;
  const rotatedHeight = cropWidth * sin + cropHeight * cos;

  // Final canvas size (only output scale to cap dimensions, no zoom scale)
  const canvasWidth = Math.floor(rotatedWidth * outputScale);
  const canvasHeight = Math.floor(rotatedHeight * outputScale);

  console.log('[canvasPreview] Final canvas dimensions:', {
    canvasWidth,
    canvasHeight,
    cropWidth,
    cropHeight,
    outputScale,
    rotate,
    note: 'scale/zoom does not affect output'
  });

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  ctx.save();
  ctx.imageSmoothingQuality = 'high';

  // Move to center of canvas
  ctx.translate(canvasWidth / 2, canvasHeight / 2);

  // Apply rotation
  ctx.rotate(rotateRads);

  // Draw the cropped image centered at natural size
  const outputWidth = cropWidth * outputScale;
  const outputHeight = cropHeight * outputScale;

  ctx.drawImage(
    image,
    cropX,        // source x
    cropY,        // source y
    cropWidth,    // source width
    cropHeight,   // source height
    -outputWidth / 2,   // dest x (centered)
    -outputHeight / 2,  // dest y (centered)
    outputWidth,        // dest width
    outputHeight        // dest height
  );

  ctx.restore();
}